export const formatAuthors = (authors: string | string[] | undefined): string => {
  if (!authors) return "";
  if (Array.isArray(authors)) return authors.join(", ");
  return authors;
};
